import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IFooterLink } from '../../interfaces/footer';
import { HandleScreenService } from '../../services/handle-screen.service';
@Component({
  selector: 'ui-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  @Input() linkFooter: IFooterLink | null = null;
  @Input() labelLeft: string = '';
  @Input() version: string | null = '';
  @Output() clickFooterLink: EventEmitter<string> = new EventEmitter<string>();
  public currentYear: number = new Date().getFullYear();

  get footerLabel(): string {
    return `© ${this.labelLeft} ${this.currentYear} Versione Software ${this.version}`;
  }

  get isMobile(): boolean {
    return this.handleScreenService.isMobile();
  }

  constructor(public mobile: HandleScreenService, private handleScreenService: HandleScreenService) { }

  footerLink(url: string): void {
    this.clickFooterLink.emit(url);
  }
}
